import { Route } from "react-router";
import { all_routes } from "./all_routes";
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Login2 from "../auth/login/login-2";
import Login3 from "../auth/login/login-3";
import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ResetPassword3 from "../auth/resetPassword/resetPassword-3";
import TwoStepVerification2 from "../auth/twoStepVerification/twoStepVerification-2";
import TwoStepVerification3 from "../auth/twoStepVerification/twoStepVerification-3";
import Register2 from "../auth/register/register-2";
import Register3 from "../auth/register/register-3";
import ForgotPassword2 from "../auth/forgotPassword/forgotPassword-2";
import ForgotPassword3 from "../auth/forgotPassword/forgotPassword-3";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";
import LockScreen from "../auth/lockScreen";
import EmailVerification2 from "../auth/emailVerification/emailVerification-2";
import EmailVerification3 from "../auth/emailVerification/emailVerification-3";
import AddLessionPlan from "../lessionplan/AddLessionPlan";
import ViewLessionPlan from "../lessionplan/ViewLessionPlan";
import AddAttendance from "../attendance/AddAttendance";
import ViewAttendance from "../attendance/ViewAttendance";
import AddAssessments from "../assessments/AddAssessments";
import ViewAssessments from "../assessments/ViewAssessments";
import Profile from "../profile";
import Training from "../training/training";
import PdfViewer from "../training/PdfViewer";
import Submissionbatch from "../submission/submissionbatch";
import GetBatches from "../GetBatches";
import AddSubunits from "../lessionplan/AddSubunits";
import LMSDashboard from "../dashboard/dashboard";
import ViewLessionUnits from "../candidate/ViewLessonUnits";
// import SelectLessonUnit from "../candidate/SelectUnit";
import VideoViewer from "../training/VideoViewer";
import GetBatchesVk from "../GetBatchesVk";
import TrainerCvSubmission from "../submission/LeadCV";
import Support from "../Support/Support";
import ViewAssessmentDetails from "../assessments/View-Assessment-details";
import RegisteredUserTable from "../Reports/RegisteredUser-reports/registeredUser-reports";
import Posttraining from "../Reports/FeedbackReports/postraining-feedback";
import Pretraining from "../Reports/FeedbackReports/pretraining-feedback";
import AttendanceReport from "../Reports/AttendanceReports/attendance-reports";
import FoodAndRoom from "../Reports/FeedbackReports/food-and-room-feedback";
import TopSubmissions from "../Reports/Top-submissionReports/top-submission-reports";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    // element: <Dashboard />,
    element: <LMSDashboard />,
    // route: Route,
  },
  {
    path: routes.getBatches,
    element: <GetBatches />,
    // route: Route,
  },
  {
    path: routes.getBatchesvk,
    element: <GetBatchesVk />,
    // route: Route,
  },
  {
    path: routes.addlessionplan,
    element: <AddLessionPlan />,
    // route: Route,
  },
  {
    path: routes.addSubUnit,
    element: <AddSubunits />,
    // route: Route,
  },
  {
    path: routes.viewlessionplan,
    element: <ViewLessionPlan />,
    // route: Route,
  },
  {
    path: routes.addattendance,
    element: <AddAttendance />,
    // route: Route,
  },
  {
    path: routes.viewattendance,
    element: <ViewAttendance />,
    // route: Route,
  },
  {
    path: routes.addassessments,
    element: <AddAssessments />,
    // route: Route,
  },
  {
    path: routes.viewassessments,
    element: <ViewAssessments />,
    // route: Route,
  },
  {
    path: routes.viewassessment_details,
    element: <ViewAssessmentDetails />,
    // route: Route,
  },
  {
    path: routes.viewprofile,
    element: <Profile />,
    // route: Route,
  },
  {
    path: routes.training,
    element: <Training />,
    // route: Route,
  },
  {
    path: routes.pdfviewer,
    element: <PdfViewer />,
    // route: Route,
  },
  {
    path: routes.videoViewer,
    element: <VideoViewer />,
    // route: Route,
  },
  {
    path: routes.leadcv,
    element: <TrainerCvSubmission />,
    // route: Route,
  },
  {
    path: routes.support,
    element: <Support />,
    // route: Route,
  },
  {
    path: routes.registeredCandidateList,
    element: < RegisteredUserTable/>,
    // route: Route,
  },
  {
    path: routes.postFeedbackForm,
    element: < Posttraining/>,
    // route: Route,
  },
  {
    path: routes.preFeedbackForm,
    element: < Pretraining/>,
    // route: Route,
  },
  {
    path: routes.foodAndRoom,
    element: < FoodAndRoom/>,
    // route: Route,
  },
  {
    path: routes.attendanceReports,
    element: < AttendanceReport/>,
    // route: Route,
  },
  {
    path: routes.topSubmission,
    element: < TopSubmissions/>,
    // route: Route,
  },
  // {
  //   path: routes.submission,
  //   element: <Submissiondashboard />,
  //   route: Route,
  // },

  // ================ Candidate ============ //
  // {
  //   path: routes.selectUnit,
  //   element: <SelectLessonUnit />,
  //   route: Route,
  // },
  // {
  //   path: routes.selectSubUnit,
  //   element: <SelectLessonUnit />,
  //   route: Route,
  // },
  // =========== end candidate ============ //

  {
    path: routes.submission,
    element: <Submissionbatch />,
    route: Route,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
  },
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.twoStepVerification3,
    element: <TwoStepVerification3 />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification2,
    element: <EmailVerification2 />,
    route: Route,
  },
  {
    path: routes.emailVerification3,
    element: <EmailVerification3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.register2,
    element: <Register2 />,
    route: Route,
  },
  {
    path: routes.register3,
    element: <Register3 />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.resetPassword3,
    element: <ResetPassword3 />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
  },
  {
    path: routes.forgotPassword3,
    element: <ForgotPassword3 />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
  },
];
// export const publicRoutes = [
//   {
//     path: "/",
//     // element: <Dashboard />,
//     element: <LMSDashboard />,
//     route: Route,
//   },
//   {
//     path: routes.getBatches,
//     element: <GetBatches />,
//     route: Route,
//   },
//   {
//     path: routes.addlessionplan,
//     element: <AddLessionPlan />,
//     route: Route,
//   },
//   {
//     path: routes.addSubUnit,
//     element: <AddSubunits />,
//     route: Route,
//   },
//   {
//     path: routes.viewlessionplan,
//     element: <ViewLessionPlan />,
//     route: Route,
//   },
//   {
//     path: routes.addattendance,
//     element: <AddAttendance />,
//     route: Route,
//   },
//   {
//     path: routes.viewattendance,
//     element: <ViewAttendance />,
//     route: Route,
//   },
//   {
//     path: routes.addassessments,
//     element: <AddAssessments />,
//     route: Route,
//   },
//   {
//     path: routes.viewassessments,
//     element: <ViewAssessments />,
//     route: Route,
//   },
//   {
//     path: routes.viewprofile,
//     element: <Profile />,
//     route: Route,
//   },
//   {
//     path: routes.training,
//     element: <Training />,
//     route: Route,
//   },
//   {
//     path: routes.pdfviewer,
//     element: <PdfViewer />,
//     route: Route,
//   },
//   {
//     path: routes.videoViewer,
//     element: <VideoViewer />,
//     route: Route,
//   },
//   // {
//   //   path: routes.submission,
//   //   element: <Submissiondashboard />,
//   //   route: Route,
//   // },

//   // ================ Candidate ============ //
//   {
//     path: routes.selectUnit,
//     element: <SelectLessonUnit />,
//     route: Route,
//   },
//   {
//     path: routes.selectSubUnit,
//     element: <SelectLessonUnit />,
//     route: Route,
//   },
//   // =========== end candidate ============ //

//   {
//     path: routes.submission,
//     element: <Submissionbatch />,
//     route: Route,
//   },
// ];
